module.exports = __webpack_public_path__ + "media/images/front/site-logo_wide-b507b19f18a3e9128afbe0b5d2146709.svg";